import type { Maybe } from '@adornis/base/utilTypes.js';

type SignupFormSource = readonly [
  timeframe: Maybe<{ _id: string }>,
  userClass: unknown,
  userEntity: Maybe<{ _id?: Maybe<string> }>,
];

export function isSameSignupFormSource(a: SignupFormSource, b: SignupFormSource): boolean {
  return a[0]?._id === b[0]?._id && a[1] === b[1] && (a[2]?._id ?? null) === (b[2]?._id ?? null);
}
